
<div class="login-sms">
  <div class="modal login-sms-modal">
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="closeModal"
    ></button>
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <div v-show="!smsSent">
          <div class="subtitle is-size-4">
            <p v-if="msg" class="msg subtitle has-text-grey">
              {{ msg }}
            </p>
            <p class="subtitle">
              {{ $t("login.enter-mobile") }}
            </p>
          </div>
          <div class="field has-addons is-fullwidth">
            <p class="control is-large">
              <a
                class="button is-info is-large is-rounded"
                style="padding: 0px 12px"
                @click="openCountryCodeModal"
                >{{ countryCode }}</a
              >
            </p>
            <div class="control has-icons-right is-expanded">
              <input
                v-model="phoneNumber"
                class="input is-large has-text-centered is-rounded"
                type="number"
                maxlength="12"
                placeholder="123456789"
                v-on:keyup="checkPhoneLength(phoneNumber, 14)"
              />
              <span class="icon is-small is-right">
                <i class="fas fa-phone"></i>
              </span>
            </div>
          </div>
          <div v-if="countryCode != '+66'">
            <br />
            <i class="label pulse"
              >Non-Thai phone numbers will receive login code via Whatsapp</i
            >
          </div>
          <br />
          <a
            class="button is-success is-medium is-rounded"
            @click="submitPhoneNumber"
            >{{ $t("confirm") }}</a
          >
        </div>

        <div v-show="smsSent">
          <p class="subtitle has-text-grey">
            {{ $t("login.sms-sent-to") }}
            <span class="link" @click="help">{{ fullNumber }}</span>
          </p>
          <p class="subtitle">
            {{ $t("login.please-enter-code") }}
          </p>
          <div class="field has-addons is-fullwidth">
            <div class="control has-icons-left has-icons-right is-expanded">
              <input
                v-model="inputCode"
                class="input is-large has-text-centered is-rounded is-fullwidth"
                type="number"
                placeholder="4-digit code"
                v-on:keyup="checkCode(false)"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-key"></i>
              </span>
            </div>
            <div class="control">
              <a
                class="button is-large is-rounded has-text-info"
                style="padding: 0px 16px"
                :disabled="resent"
                @click="resendSMS"
              >
                <i class="fa fa-redo-alt" />
              </a>
            </div>
          </div>
          <br />
          <a
            class="button is-success is-medium is-rounded"
            @click="checkCode(true)"
            >{{ $t("submit") }}</a
          >
        </div>
        <div v-if="smsSent" style="margin-top: 20px">
          <p @click="showEmailLogin = !showEmailLogin">
            <i class="link has-text-grey">{{
              $t("login.get-code-via-email")
            }}</i>
          </p>

          <div
            v-if="showEmailLogin"
            class="field has-addons is-fullwidth"
            style="margin-top: 10px; padding-bottom: 10px"
          >
            <div class="control has-icons-left is-expanded">
              <input
                v-model="email"
                class="input is-fullwidth is-rounded is-medium"
                :placeholder="$t('login.enter-email-address')"
              />
              <span class="icon is-small is-left">
                <i class="far fa-envelope"></i>
              </span>
            </div>
            <div class="control">
              <a
                class="button has-text-info is-rounded is-medium"
                :disabled="!validEmail"
                @click="sendEmailCode"
              >
                <i class="fa fa-paper-plane" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="error" style="margin-top: 10px">
          <p class="has-text-danger">{{ error }}</p>
        </div>
      </section>
    </div>
  </div>
  <CountryCodeModal @countryCode="onCountryCode" />
</div>
